import { Routes } from "@angular/router";
import {
  COURSE_MENU_ITEM_ROUTE,
  COURSE_ROUTE_PARAM,
  COURSE_SESSIONS_PATH,
  EMERGENCY_HELP_PATH,
  HOME_PATH,
  MY_JOURNALS_PATH,
  UPDATE_PROFILE,
} from "@sdk/lib/values/shared-paths";

export const FULL_ROUTES: Routes = [
  {
    path: HOME_PATH,
    loadComponent: () =>
      import("../../home/home-page.component").then((m) => m.HomePageComponent),
    title: "pageTitle.dashboard",
  },
{
    path: MY_JOURNALS_PATH,
    loadComponent: () =>
      import("../../journal/journal.component").then(
        (journalComponent) => journalComponent.JournalComponent,
      ),
    title: "pageTitle.myJourney",
  },
  {
    path: COURSE_SESSIONS_PATH,
    loadComponent: () =>
      import("../../course-sessions/course-sessions.component").then(
        (courseSessionsComponent) =>
          courseSessionsComponent.CourseSessionsComponent,
      ),
    title: "pageTitle.courseSessions",
  },
  {
    path: `${COURSE_MENU_ITEM_ROUTE}/:${COURSE_ROUTE_PARAM}`,
    loadComponent: () =>
      import(
        "../../course-menu-item-view/course-menu-item-view.component"
      ).then(
        (courseMenuItemComponent) =>
          courseMenuItemComponent.CourseMenuItemViewComponent,
      ),
    title: "",
  },
  {
    path: `${UPDATE_PROFILE}`,
    loadComponent: () =>
      import("../../edit-patient-profile/edit-patient-profile.component").then(
        (editPatientProfileComponent) =>
          editPatientProfileComponent.EditPatientProfileComponent,
      ),
    title: "pageTitle.updateProfile",
  },
  {
    path: EMERGENCY_HELP_PATH,
    loadComponent: () => import('../../emergency-help/emergency-help.component').then(m => m.EmergencyHelpComponent),
    title: "pageTitle.emergencyHelp",
  },
];
